<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-row>
          <a-col :span="12">
            <a-form-item label="还证编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['number']" disabled/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="授信银行" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                option-label-prop="tt"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-decorator="[
              'bank_id',
              {
                rules: [
                  { required: true, message: '必填项，请填写信息' },
                ],
              },
            ]"
                placeholder="请输入银行"
                :default-active-first-option="false"
                @search="this.bankSearch"
                @change="handleBankChange"
              >
                <a-select-option v-for="d in bankList" :key="d.id" :tt="d.name">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="银行信用证编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bank_credit_letter_number', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="银行信用证编号" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="信用证货币金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="人民币金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['amount_cny', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="汇率" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['to_cny_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
              <span style="padding-left: 10px;">（信用证货币到人民币）</span>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="融资利率（%）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['financing_rate', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="总计费用" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :precision="2" style="width: 50%" v-decorator="['total_amount', {rules: [{required: true, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="还款时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-date-picker
                v-decorator="['repayment_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
                format="YYYY-MM-DD"
                placeholder="还款时间"
                value-format="yyyy-MM-DD"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="false">
            <a-form-item label="已存档" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch v-decorator="['is_archived', {valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-textarea :auto-size="{ minRows:1, maxRows:4 }" v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}]}]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6" :offset="4">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import { credit_letter_repayment_list, credit_letter_repayment_update } from '@/api/trade_credit_letter_repayment'
import pick from 'lodash.pick'
import { bank_list } from '@/api/trade_bank'
import debounce from 'lodash/debounce'
const fields = ['id', 'number', 'is_archived', 'bank_id', 'bank_credit_letter_number', 'amount', 'amount_cny', 'to_cny_rate', 'financing_rate', 'total_amount', 'repayment_date', 'remark']
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.bankSearch = debounce(this.handleBankSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      currency: this.$Dictionaries.currency,
      data: {},
      bankList: []
    }
  },
  created () {
    this.handleBankSearch(undefined)
    this.form.setFieldsValue(pick(this.record, fields))
  },
  mounted () {
    credit_letter_repayment_list({ id: this.$route.params.id })
      .then(res => {
        console.log(res.data, '我是数据列表@')
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          // this.data.currency = '' + this.data.currency
          this.id = this.data.id
          this.loadEditInfo(this.data)
        }
      })
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          credit_letter_repayment_update(values, this.id)
            .then((res) => {
              this.handleGoBack()
              console.log(res, '修改成功')
            })
        }
      })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        console.log('formData', formData)
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    },
    handleBankSearch (value) {
      bank_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.bankList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleBankChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleBankSearch(value)
      }
    }
  }
}
</script>
